import React from 'react'
import { NavLink } from 'react-router-dom';

const NavBar = () => {
    return (
        <nav className="site-main-menu">
            <ul>
                <li>
                    <NavLink to={process.env.PUBLIC_URL + "/"}><span className="menu-text">Home</span></NavLink>
                </li>



                <li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/"}><span className="menu-text">For Authors</span></NavLink>
                    <span className="menu-toggle"><i className="far fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        <li><NavLink to={process.env.PUBLIC_URL + "/callforpaper"}><span className="menu-text">Call for Paper</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/submission"}><span className="menu-text">Submission</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/deadlines"}><span className="menu-text">Deadlines</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/specialsession"}><span className="menu-text">Special Sessions</span></NavLink></li>
                        {/* <li><NavLink to={process.env.PUBLIC_URL + "/competition"}><span className="menu-text">ICSI-OC&apos;2023</span></NavLink></li> */}
                        <li><NavLink to={process.env.PUBLIC_URL + "/registration"}><span className="menu-text">Author Registration</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/registration_pub"}><span className="menu-text">Public Registration</span></NavLink></li>
                    </ul>
                </li>

                <li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/"}><span className="menu-text">For Participants</span></NavLink>
                    <span className="menu-toggle"><i className="far fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        <li><NavLink to={process.env.PUBLIC_URL + "/venue"}><span className="menu-text">Venue</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/virtual"}><span className="menu-text">Virtual Meeting</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/transportation"}><span className="menu-text">Transportation</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/accommodation"}><span className="menu-text">Accommodation</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/scenery"}><span className="menu-text">Scenery</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/receptionBanquet"}><span className="menu-text">Reception &amp; Banquet</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/visa"}><span className="menu-text">Visa</span></NavLink></li>
                    </ul>
                </li>
                {/* <li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/"}><span className="menu-text">中文参会通道</span></NavLink>
                    <span className="menu-toggle"><i className="far fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        <li><NavLink to={process.env.PUBLIC_URL + "/submission_zn"}><span className="menu-text">论文提交</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/competition_zn"}><span className="menu-text">ICSI-OC&apos;2022</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/venue_zn"}><span className="menu-text">活动会场</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/transportation_zn"}><span className="menu-text">交通方式</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/accommodation_zn"}><span className="menu-text">住宿</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/scenery_zn"}><span className="menu-text">风景名胜</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/receptionBanquet_zn"}><span className="menu-text">接待 	&amp; 宴会</span></NavLink></li>
                    </ul>
                </li> */}

                <li className="has-children">
                    <NavLink to={process.env.PUBLIC_URL + "/"}><span className="menu-text">The Conference</span></NavLink>
                    <span className="menu-toggle"><i className="far fa-angle-down"></i></span>
                    <ul className="sub-menu">
                        <li><NavLink to={process.env.PUBLIC_URL + "/program"}><span className="menu-text">Program</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/sessions"}><span className="menu-text">Parallel Sessions</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + "/speakers"}><span className="menu-text">Speakers</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + `/tutorials`}><span className="menu-text">Tutorials</span></NavLink></li>
                        {/* <li><NavLink to={process.env.PUBLIC_URL + `/Symposia`}><span className="menu-text">Symposia</span></NavLink></li> */}
                        <li><NavLink to={process.env.PUBLIC_URL + `/committees`}><span className="menu-text">Committees</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + `/sponsors`}><span className="menu-text">Sponsors</span></NavLink></li>
                        <li><NavLink to={process.env.PUBLIC_URL + `/history`}><span className="menu-text">History</span></NavLink></li>
                    </ul>
                </li>
                {/* <li>
                    <NavLink to={process.env.PUBLIC_URL + "/contact"}><span className="menu-text">ICSI-OC &apos;2023</span></NavLink>
                </li> */}
                <li>
                    <NavLink to={process.env.PUBLIC_URL + "/contact"}><span className="menu-text">Contact Us</span></NavLink>
                </li>
            </ul>
        </nav>
    )
}

export default NavBar
